<template>
  <div>
    <FlashMessage color="is-info"></FlashMessage>
    <div class="card">
      <div class="card-content">
        <vue-element-loading :active="isLoading" spinner="spinner" />
        <div class="field has-addons">
          <div class="control">
            <input
              class="input bulmaCalendar"
              type="date"
              name="formdate"
              v-model="formdate"
            />
          </div>
          <div class="control">
            <a class="button is-info" @click="onSubmit">
              Search
            </a>
          </div>
        </div>
        <div v-if="formdate">
          <span class="tag is-link is-light reset-tag" @click="resetDate"
            >Reset</span
          >
        </div>

        <table class="table is-fullwidth is-hoverable">
          <thead>
            <tr>
              <th width="30%">{{ $t("DateTime") }}({{ timezone }})</th>
              <th width="30%">{{ $t("devices.deviceId") }}</th>
              <th>{{ $t("devices.deviceLocate") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in eventsList"
              :key="index"
              class="movie-link"
            >
              <td class="movie-link">
                <router-link
                  :to="{
                    name: 'movieView',
                    params: {
                      projectId: item.projectId,
                      deviceId: item.deviceId,
                      eventDateTime: item.eventDateTime,
                    },
                    query: {
                      mode: mode,
                      date: formdate,
                    },
                  }"
                >
                  <DateFormat :timestamp="item.eventDateTime" />
                </router-link>
                <router-link
                  :to="{
                    name: 'movieView',
                    params: {
                      projectId: item.projectId,
                      deviceId: item.deviceId,
                      eventDateTime: item.eventDateTime,
                    },
                    query: {
                      mode: mode,
                      date: formdate,
                    },
                  }"
                  target="_blank"
                >
                  <i class="ml-1 fas fa-external-link-alt"></i>
                </router-link>
              </td>
              <td>{{ item.deviceId }}</td>
              <td>{{ item.deviceLocate }}</td>
            </tr>
          </tbody>
        </table>
        <div v-if="hasNext.lt">
          <button
            class="button is-link is-light is-fullwidth is-small"
            @click="getList"
          >
            <i class="fas fa-chevron-down"></i> &nbsp;
            {{ $t("events.nextEvents") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FlashMessage from "@/components/FlashMessage.vue";
import imsr from "@/imsr-api";
import { ref, computed } from "vue";
import { useStore } from "vuex";
import VueElementLoading from "vue-element-loading";
import { useRouter } from "vue-router";
import DateFormat from "@/components/DateFormat.vue";
export default {
  components: {
    VueElementLoading,
    FlashMessage,
    DateFormat,
  },
  props: {
    tenantId: {
      type: String,
      required: true,
    },
    projectId: {
      type: String,
      required: true,
    },
    limit: {
      type: Number,
      default: 30,
    },
    deviceId: {
      type: String,
      default: null,
    },
    date: {
      type: String,
      default: null,
    },
    mode: {
      type: String,
      default: "data",
    },
  },
  setup(props) {
    const router = useRouter();
    const store = useStore();
    const eventsList = ref([]);
    const isLoading = ref(false);
    const formdate = ref(props.date);
    const hasNext = ref({ ld: null, lt: null });

    const getList = async () => {
      try {
        isLoading.value = true;
        // eventsList.value = [];
        let params = {
          tenantId: props.tenantId,
          projectId: props.projectId,
          limit: props.limit,
        };
        if (props.deviceId != "") {
          params.deviceId = props.deviceId;
        }
        if (formdate.value != "") {
          params.date = formdate.value;
        }
        if (hasNext.value.ld != null) {
          params.ld = hasNext.value.ld;
          params.lt = hasNext.value.lt;
        }
        const res = await imsr.imsrGetApi("/events/list", params);
        if (Object.keys(res.le).length) {
          hasNext.value = res.le;
        } else {
          hasNext.value = { lt: null, ld: null };
        }
        res.events.forEach((item) => {
          eventsList.value.push({
            eventDateTime: item.eventDateTime,
            datetime: item.eventDateTime,
            deviceId: item.deviceId,
            deviceLocate: item.deviceLocate,
            file: item.file,
            tenantId: item.tenantId,
            projectId: item.projectId,
          });
        });
        isLoading.value = false;
      } catch (e) {
        router.push({ name: "InternalServerError" });
      }
    };
    getList();

    const onSubmit = () => {
      if (formdate.value) {
        eventsList.value = [];
        hasNext.value = { lt: null, ld: null };
        formdate.value = formdate.value.replace("/", "-");
        getList();
      }
    };

    const resetDate = () => {
      formdate.value = "";
      getList();
    };
    return {
      timezone: computed(() => store.getters.timezone),
      eventsList,
      isLoading,
      formdate,
      onSubmit,
      resetDate,
      getList,
      hasNext,
    };
  },
};
</script>
